import { render, staticRenderFns } from "./SelectRegis.vue?vue&type=template&id=60e53a5b&"
import script from "./SelectRegis.vue?vue&type=script&lang=js&"
export * from "./SelectRegis.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegis.vue?vue&type=style&index=0&id=60e53a5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports